import PickupZones from ".";

export const pickupZoneRoutes = [
  {
    path: "/pickupZones",
    element: <PickupZones />,
  }
];
